export default {
  actions: 'アクション',
  view: '表示',
  edit: '編集',
  delete: '削除',
};
